<script>
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDatatable from "@components/base-datatable";
import { groupsMethods } from "@state/helpers";
import { required, minLength } from "vuelidate/lib/validators";
import GroupsCreateForm from "@views/management/groups/create-form";
import GroupsUpdateForm from "@views/management/groups/update-form";

export default {
  page: {
    title: "Administration/Groups",
    meta: [{ name: "Groups management", content: "Administration/Groups" }],
  },
  components: { Layout, PageHeader, BaseDatatable, GroupsCreateForm, GroupsUpdateForm },
  data() {
    return {
      title: "Administration/Groups",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Administration/Groups",
          active: true,
        },
      ],
      tableHeaders: [
        {
          key: "name",
          label: this.$t("groupsSection.name"),
          sortable: true,
        },
        {
          key: "group_info__description",
          label: this.$t("groupsSection.description"),
          sortable: true,
        },
        {
          key: "usersId",
          label: this.$t("groupsSection.users_count"),
        },
        {
          key: "permissions",
          label: this.$t("groupsSection.permissions_count"),
        },
        {
          key: "actions",
          label: this.$t("basic.actions"),
        },
      ],
      action: "",
      createForm: {
        name: "",
        description: "",
        usersId: [],
        permissions: [],
      },
      updateForm: {
        name: "",
        description: "",
        usersId: [],
        permissions: [],
      },
      createUpdateModal: {
        id: "create-update-modal",
        title: "",
      },
      detailModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      toDelete: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
      actionsLoadings: {},
    };
  },
  validations: {
    createForm: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    updateForm: {
      name: {
        required,
        minLength: minLength(4),
      },
      usersId: {},
      permissions: {},
    },
  },
  methods: {
    ...groupsMethods,

    myProvider(ctx) {
      const promise = this.fetchGroups(this.$table_params(ctx));
      return promise
        .then((data) => {
          return data;
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
          return [];
        });
    },
    openDetailModal(item, index, button) {
      let context = this;
      context.isSubmitting = true;
      context.actionsLoadings[button] = true;
      context.detailModal.title = context.$t("groupsSection.group") + `: ${item.name}`;
      const promise = context.fetchGroupsDetail(item.url);
      return promise
        .then((data) => {
          context.detailModal.content = data;
          context.detailModalShow = !context.detailModalShow;
          context.isSubmitting = false;
          context.actionsLoadings[button] = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
          context.actionsLoadings[button] = false;
        });
    },
    resetdetailModal() {
      this.detailModal.title = "";
      this.detailModal.content = "";
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = "";
      if (action === "create") {
        this.createForm.name = "";
        this.createForm.description = "";
        this.createForm.usersId = [];
        this.updateForm.permissions = [];
        this.$v.createForm.$reset();
      } else {
        this.updateForm.name = "";
        this.updateForm.description = "";
        this.updateForm.usersId = [];
        this.updateForm.permissions = [];
        this.$v.updateForm.$reset();
      }
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action);
      if (action === "create") {
        this.action = "create";
        this.createUpdateModal.title =
          this.$t("new") + " " + this.$t("groupsSection.group");
      } else {
        this.action = "update";
        this.updateForm._id = item._id;
        this.updateForm.name = item.name;
        this.updateForm.description = item.description;
        this.updateForm.usersId = Array.from(item.usersId, (x) => x._id);
        this.updateForm.permissions = Array.from(item.permissions, (x) => x._id);
        this.createUpdateModal.title =
          this.$t("update") + " " + this.$t("groupsSection.group");
      }
      this.createUpdateModalShow = !this.createUpdateModalShow;
    },
    onFormSubmit(evt) {
      evt.preventDefault();
      let context = this;
      context.isSubmitting = true;
      if (context.$v.createForm.$anyError) {
        context.$v.createForm.$touch();
      }
      let form = context.action === "create" ? context.createForm : context.updateForm;
      const promise = context.createUpdateGroups(form);
      return promise
        .then((data) => {
          if (form.url) {
            context.$generate_toast(
              context,
              "success",
              context.$t("alerts.updated_successfully")
            );
          } else {
            context.$generate_toast(
              context,
              "success",
              context.$t("alerts.created_successfully")
            );
          }
          context.createUpdateModalShow = !context.createUpdateModalShow;
          context.$refs.table.refresh();
          context.isSubmitting = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
        });
    },
    openDeleteModal(item, index) {
      let context = this;
      context.toDelete = item;
      context.deleteModalShow = !context.deleteModalShow;
    },
    resetDeleteModal(item, index) {
      this.toDelete = {};
    },
    deleteGroup() {
      let context = this;
      context.isSubmitting = true;
      const promise = context.deleteGroups(context.toDelete._id);
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            "success",
            context.$t("alerts.deleted_successfully")
          );
          context.$refs.table.refresh();
          context.isSubmitting = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card>
            <b-button
              variant="primary"
              size="sm"
              @click="openCreateUpdateModal(null, null, 'create')"
            >
              <i class="fad fa-plus"></i> {{ $t("basic.add") }}
            </b-button>
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template v-slot:cell(group_info__description)="row">
                {{ row.item.group_info ? row.item.group_info.description : "" }}
              </template>
              <template v-slot:cell(usersId)="row">
                {{ row.value.length }}
              </template>
              <template v-slot:cell(permissions)="row">
                {{ row.value.length }}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    variant="transparent-1"
                    class="text-info p-1"
                    :disabled="isSubmitting || actionsLoadings[`info-btn-${row.index}`]"
                    @click="openDetailModal(row.item, row.index, `info-btn-${row.index}`)"
                  >
                    <i
                      v-if="!actionsLoadings[`info-btn-${row.index}`]"
                      class="fad fa-circle-info fe-2x"
                    ></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                    >
                    </b-spinner>
                  </b-button>
                  <b-tooltip
                    :target="`info-btn-${row.index}`"
                    triggers="hover"
                    placement="left"
                    variant="info"
                  >
                    {{ $t("basic.info") }}
                  </b-tooltip>

                  <b-button
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="transparent-1"
                    class="text-warning p-1"
                    @click="openCreateUpdateModal(row.item, row.index, 'update')"
                  >
                    <i class="fad fa-pen fe-2x"></i>
                  </b-button>
                  <b-tooltip
                    :target="`update-btn-${row.index}`"
                    triggers="hover"
                    placement="left"
                    variant="warning"
                  >
                    {{ $t("basic.edit") }}
                  </b-tooltip>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="transparent-1"
                    class="text-danger p-1"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <i class="fad fa-trash-xmark"></i>
                  </b-button>
                  <b-tooltip
                    :target="`delete-btn-${row.index}`"
                    triggers="hover"
                    placement="left"
                    variant="danger"
                  >
                    {{ $t("basic.delete") }}
                  </b-tooltip>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <!-- Detail modal -->
    <b-modal
      :id="detailModal.id"
      v-model="detailModalShow"
      :title="detailModal.title"
      ok-only
      @hide="resetdetailModal"
    >
      <!-- <pre>{{ detailModal.content }}</pre> -->
      <table class="table-hover table-sm mb-0">
        <tr>
          <th style="text-align: right">{{ $t("groupsSection.name") }}</th>
          <td>
            {{ _.capitalize(detailModal.content.name) }}
          </td>
        </tr>
        <tr>
          <th style="text-align: right">{{ $t("groupsSection.description") }}</th>
          <td>
            {{
              detailModal.content.group_info
                ? detailModal.content.group_info.description
                : ""
            }}
          </td>
        </tr>
        <tr>
          <th style="text-align: right">{{ $t("groupsSection.permissions") }}</th>
          <td v-if="detailModal.content.permissions_info">
            <ul>
              <li
                v-for="(permission, index) in detailModal.content.permissions_info"
                :key="index"
              >
                {{ permission.name }}
              </li>
            </ul>
          </td>
          <td v-else class="text-muted">No permissions assigned</td>
        </tr>
        <tr>
          <th style="text-align: right">{{ $t("groupsSection.members") }}</th>
          <td v-if="detailModal.content.users_set_info">
            <ul>
              <li
                v-for="(user, index) in detailModal.content.users_set_info"
                :key="index"
              >
                {{
                  user.first_name
                    ? `${user.first_name} ${user.last_name} (${user.username})`
                    : user.username
                }}
              </li>
            </ul>
          </td>
          <td v-else class="text-muted">No group members</td>
        </tr>
      </table>
    </b-modal>
    <!-- Create-Update modal -->
    <b-modal
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      :size="action === 'create' ? 'sm' : 'lg'"
    >
      <GroupsCreateForm
        v-if="action === 'create'"
        :validator="$v.createForm"
        :onformsubmit="onFormSubmit"
        :form="createForm"
      >
      </GroupsCreateForm>
      <GroupsUpdateForm
        v-if="action === 'update'"
        :validator="$v.updateForm"
        :onformsubmit="onFormSubmit"
        :form="updateForm"
      >
      </GroupsUpdateForm>
      <template v-slot:modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="float-right"
          @click="createUpdateModalShow = !createUpdateModalShow"
        >
          {{ $t("basic.cancel") }}
        </b-button>
        <b-button
          type="submit"
          form="form"
          size="sm"
          variant="primary"
          :disabled="
            action === 'create'
              ? $v.createForm.$invalid || isSubmitting
              : $v.updateForm.$invalid || isSubmitting
          "
        >
          <span v-if="!isSubmitting">
            {{ $t("submit") }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- Delete modal -->
    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      :title="$t('basic.delete') + ' ' + $t('groupsSection.group')"
      :ok-title="$t('basic.delete')"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteGroup"
    >
      <p>
        {{ $t("groupsSection.are_you_sure") }}
        <b>{{ toDelete ? toDelete.name : "" }}</b> ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary" @click="cancel">
          {{ $t("basic.cancel") }}
        </b-button>
        <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
          <span v-if="!isSubmitting">
            {{ $t("delete") }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
